export enum QuitButtonAction {
    ExitSurvey,
    BranchTo,
}
